/**
 * To use with type declared as const, so it can be assigned to mutable prop
 *
 * In general we don't strictly declare readonly arrays and objects in our codebase.
 * This leads to problems when something is declared as readonly for reason like
 * more exact inference, but then all usages would have to be redeclared as readonly
 * all the way up.
 *
 * @example
 *
 * const placeholderWords = unreadonly(['foo', 'bar', 'baz'] as const);
 * type PlaceholderWord = typeof placeholderWords[number];
 */

export const unreadonly = <T>(x: readonly T[]): T[] => x as T[];
